import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import actionTypes from "./actionTypes";
export const initialState = {
    sourceTaskIds: [],
    title: "",
    show: false
};
export default createReducer(initialState, {
    [actionTypes.TOGGLE_TASKS_LOGS_RESULTS]: (state, { sourceTaskIds, show, title }) => {
        let result = set(state, "sourceTaskIds", sourceTaskIds);
        result = set(result, "title", title);
        return set(result, "show", show);
    }
});
